import React, { useState } from "react";
import PropTypes from "prop-types";

const fallbackBg = ["#3b3b3b"];

function UserCard({ profile, height = 120 }) {
  const [imgError, setImgError] = useState(false);

  const fullName = `${profile.first_name ?? ""} ${profile.last_name ?? ""}`.trim() || "User";
  const initials = fullName
    .split(" ")
    .filter(Boolean)
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return (
    <div
      style={{
        height,
        width: "100%",
        maxWidth: "min(340px, 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "min(16px, 3vw)",
        padding: "0px min(20px, 4vw)",
        borderRadius: 16,
        background: "#ffffff",
        WebkitBackdropFilter: "blur(10px) saturate(180%)",
        fontFamily: "Inter, sans-serif",
        color: "#1F2937",
        margin: "0 auto",
        boxSizing: "border-box",
      }}
    >
      {/* Avatar / initials */}
      {profile.avatar && !imgError ? (
        <img
          src={profile.avatar}
          alt={fullName}
          onError={() => setImgError(true)}
          style={{
            width: "min(72px, 20vw)",
            height: "min(72px, 20vw)",
            borderRadius: "50%",
            objectFit: "cover",
            flexShrink: 0,
            boxShadow: "0 0 0 3px rgba(255,255,255,0.9)",
          }}
        />
      ) : (
        <div
          style={{
            width: "min(72px, 20vw)",
            height: "min(72px, 20vw)",
            borderRadius: "50%",
            background: fallbackBg[fullName.charCodeAt(0) % fallbackBg.length],
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            fontWeight: 700,
            fontSize: "min(26px, 5vw)",
            flexShrink: 0,
            boxShadow: "0 0 0 3px rgba(255,255,255,0.9)",
          }}
        >
          {initials}
        </div>
      )}

      {/* Greeting + details */}
      <div style={{ lineHeight: 1.3, minWidth: 0, flex: 1 }}>
        <div style={{ fontSize: "min(14px, 3.5vw)", letterSpacing: 0.4, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
          Welcome back,
        </div>
        <div style={{ fontSize: "min(22px, 5vw)", fontWeight: 700, marginTop: -2, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
          {fullName}
        </div>
        <div style={{ fontSize: "min(13px, 3.2vw)", color: "#374151", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
          {profile.role} 
        </div>
      </div>
    </div>
  );
}

UserCard.propTypes = {
  profile: PropTypes.shape({
    avatar:        PropTypes.string,
    first_name:    PropTypes.string,
    last_name:     PropTypes.string,
    role:          PropTypes.string,
    // department_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  /** Card height – number (px) or any CSS length (e.g. "8rem", "30vh") */
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default UserCard;